import { CheckedError } from '@app/core/errors/errors/checked-error.interface';

export interface BaseState<T> {
  failed?: boolean | CheckedError;
  success?: boolean;
  busy?: boolean;
  data?: T;
}

export const initializeBaseState = <T>(initialData: T = undefined): BaseState<T> => ({
  failed: false,
  success: false,
  busy: false,
  data: initialData,
});

export const initializeBaseStateWithoutData = <T>(): BaseState<T> => ({
  failed: false,
  success: false,
  busy: false,
});
